import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  faPencil,
  faCloudArrowUp,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
  bannerImage,
  bannerurl,
} from "../../../../slice/Features/uploadBanner";
import { currentFeature } from "../../../../slice/features";

import axios from "axios";
import { toast } from "react-toastify";
import lang from "../../../../assets/lang/toastMsg.json";
import image from "../../../../assets/lang/icons.json";
import style from "./banner.module.css";
import BodyLoading from "../../Loading/BodyLoading";
import Pro from "../../Pro/Pro";
import { Tooltip } from "@mui/material";

const Banner = () => {
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const userImages = useSelector((state) => state.userImages);
  const userData = useSelector((state) => state.user);

  const [bodyLoading, setBodyLoading] = useState(false);

  const [bannerUrlInput, setBannerUrlInput] = useState({
    bannerUrl: userData.bannerurl[0].bannerUrl,
  });

  const handleInput = (e) => {
    e.preventDefault();

    setBannerUrlInput({ ...bannerUrlInput, [e.target.name]: e.target.value });
  };

  const imgref = useRef("");

  const [bannerImageUrl, setBannerImageUrl] = useState(
    userImages.bannerImage[0].bannerImageUrl
  );

  const resetBannerImage = async () => {
    try {
      const response = await axios.post("/banner-img-delete");
      if (response.data.status === 200) {
        setBannerImageUrl("");
        toast.info(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const CancelFeature = (e) => {
    e.preventDefault();

    dispatch(currentFeature(""));
  };

  const saveFeature = async (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
    try {
      const data = {
        image: bannerImageUrl,
        url: bannerUrlInput.bannerUrl,
      };

      const response = await axios.post("/add/upload-banner", data);
      if (response.data.status === 200) {
        console.log(response.data);
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const bannerImageFuc = () => {
    return (
      <div className={`${style.editImage}`}>
        <span className={`${style.editImgIcon} text-center text-dark`}>
          <span className="d-block">Drag And Drop Your Banner Here</span>
          <span className="d-block mb-3" style={{ color: "silver" }}>
            Or
          </span>
          <span
            className="bg-info p-3 text-white"
            style={{ borderRadius: "5px" }}
          >
            <FontAwesomeIcon
              color="white"
              icon={faCloudArrowUp}
              className="me-2"
            />
            Choose File To Upload
          </span>
        </span>
        {isAuth ? (
          <input
            type="file"
            name="bannerImage"
            onChange={handleBannerImgInput}
            ref={imgref}
          ></input>
        ) : (
          <input
            type="text"
            style={{ cursor: "default" }}
            onClick={() => {
              toast.info(`${lang.loginFirstBanner}`, {
                closeOnClick: true,
                theme: "colored",
              });
            }}
          ></input>
        )}
      </div>
    );
  };

  const handleBannerImgInput = async (e) => {
    e.preventDefault();

    if (isAuth) {
      const formdata = new FormData();
      formdata.append("bannerImage", e.target.files[0]);
      if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
        toast.warn(`${lang.imageValid}`, {
          closeOnClick: true,
          theme: "colored",
        });
        return false;
      }
      try {
        setBodyLoading(true);
        const response = await axios.post("/bannerImage", formdata, {
          headers: {
            "Content-Type": "multipart/form-data ",
          },
        });
        if (response.data.status === 200) {
          setBannerImageUrl(response.data.imgUrl);
          setBodyLoading(false);
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      toast.info(`${lang.loginFirst}`, {
        closeOnClick: true,
        theme: "colored",
      });
      return false;
    }
  };

  const userTempName = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;

      var image = "";
      var url = "";

      if (user.upload_banner_id !== null) {
        image = user.upload_banner.image;
        url = user.upload_banner.url;
      }
      const userdata = {
        bannerUrl: url !== null ? url : "",
      };

      setBannerImageUrl(image !== "" ? image : "");
      dispatch(bannerImage(image !== "" ? image : ""));
      setBannerUrlInput(userdata);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(bannerurl(bannerUrlInput));
    dispatch(bannerImage(bannerImageUrl));
  }, [bannerUrlInput, bannerImageUrl, dispatch, isAuth]);

  useEffect(() => {
    if (isAuth) {
      userTempName();
    }
  }, [dispatch, isAuth]);

  return (
    <div className={`text-start ${style.profileForm}`}>
      <h6>Upload Your Banner (jpg, png, gif)</h6>
      <span>
        For best Image quailty , we recommenend to use upto 520px width
      </span>
      {bodyLoading ? <BodyLoading /> : null}
      <div className="" style={{ minHeight: "650px" }}>
        {/* <span className=" custom-header">Enter Your Banner Details</span> */}

        <div className="my-3 position-relative container-fluild">
          {bannerImageFuc()}
        </div>
        {bannerImageUrl !== "" &&
        bannerImageUrl !== null &&
        bannerImageUrl !== `${image.staticBannerImage}` ? (
          <>
            <div className={`${style.displayBannerImg}`}>
              <span className="custom-label  my-1 d-block">Banner Image</span>
              {isAuth ? (
                <img src={`${image.imageUrl}/${bannerImageUrl}`} alt="noimg" />
              ) : (
                <img
                  src={`${
                    bannerImageUrl === `${image.staticImage}`
                      ? `${image.imageUrl}/${bannerImageUrl}`
                      : bannerImageUrl
                  }`}
                  alt="noimg"
                />
              )}
            </div>

            <div className="mt-3 position-relative">
              <label className="custom-label ">Banner URL</label>
              {/* <Pro marginValue="5px" /> */}

              <input
                type="text"
                name="bannerUrl"
                placeholder="https://"
                autoComplete="off"
                value={bannerUrlInput.bannerUrl}
                onChange={handleInput}
              ></input>
              <span className={`${style.profileFormInputIcon}`}>
                <FontAwesomeIcon icon={faPencil} />
              </span>
            </div>

            <div
              className=" py-2 px-3 d-flex flex-wrap"
              style={{ background: "silver" }}
            >
              {/* <div
                className={`${style.replaceBanner} ms-2`}
                style={{ width: "200px" }}
              >
                <span onChange={handleBannerImgInput}>
                  <FontAwesomeIcon icon={faRepeat} /> Replace Your Banner
                </span>
              </div> */}
              <button
                className={`${style.btnReset}`}
                onClick={resetBannerImage}
              >
                <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
                Delete
              </button>
            </div>
          </>
        ) : null}
      </div>

      <div className="my-3">
        <button
          className={`btn btn-primary me-2 ${
            bannerImageUrl !== "" &&
            bannerImageUrl !== null &&
            bannerImageUrl !== `${image.staticBannerImage}`
              ? ""
              : "disabled"
          }`}
          onClick={saveFeature}
        >
          save
        </button>
        <button className="btn btn-outline-secondary" onClick={CancelFeature}>
          Cancel
        </button>
      </div>
    </div>
  );
};
export default Banner;
